"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@headlessui/react");
var react_2 = __importDefault(require("react"));
function JetActionMessage(_a) {
    var on = _a.on, className = _a.className, children = _a.children;
    return (react_2.default.createElement("div", { className: className },
        react_2.default.createElement(react_1.Transition, { show: on, leave: "transition ease-in duration-1000", "leave-from-class": "opacity-100", leaveTo: "opacity-0" },
            react_2.default.createElement("div", { className: "text-sm text-gray-600" }, children))));
}
exports.default = JetActionMessage;
